// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "c808112752f7e8fe5a9724623ae304d3" + ".css";
};